import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "carousel",
  class extends Controller {
    static values = { itemsCount: Number, index: Number }
    static targets = ["buttonNext", "buttonPrevious", "slide", "pagerCurrent"]
    static classes = ["currentSlide"]

    next() {
      if (this.indexValue === this.itemsCountValue - 1) {
        this.indexValue = 0
      } else {
        this.indexValue++
      }
    }

    previous() {
      if (this.indexValue === 0) {
        this.indexValue = this.itemsCountValue - 1
      } else {
        this.indexValue--
      }
    }

    indexValueChanged() {
      this.slideTargets.forEach((slide, index) => {
        slide.classList.toggle(this.currentSlideClass, index === this.indexValue)
      })
      if (this.hasPagerCurrentTarget) {
        this.pagerCurrentTarget.textContent = this.indexValue + 1
      }
    }

    get currentSlide() {
      return this.slideTargets[this.indexValue]
    }
  },
)
